import type { ResidentPresentation } from "../sim/neighborhood/index.ts";

/**
 * Room snapshots contain the authoritative scheduled named residents. The
 * browser presentation also contains terrain-grounded, tile-local residents
 * (ambient pedestrians and venue occupants) which cannot be reconstructed by
 * the room server. Once that composite presentation exists, keep it intact
 * until the render loop recomputes it from the newly applied room state.
 *
 * Replacing it with the smaller server list between animation frames makes
 * ambient actors disappear for one rendered frame and then be allocated again.
 */
export function residentSeedForAppliedRoomSnapshot(
  authoritativeNamedResidents: readonly Readonly<ResidentPresentation>[],
  currentLocalResidents: readonly Readonly<ResidentPresentation>[],
): readonly Readonly<ResidentPresentation>[] | null {
  return currentLocalResidents.length === 0
    ? authoritativeNamedResidents
    : null;
}
